import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-qygl",
  "use": "icon-qygl-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 20 20\" id=\"icon-qygl\"><path stroke=\"#666768\" stroke-linecap=\"round\" d=\"M9.571 4H5a1 1 0 0 0-1 1v9.143a1 1 0 0 0 1 1h9.143a1 1 0 0 0 1-1V9.57\" /><path stroke=\"#666768\" stroke-linecap=\"round\" d=\"M7.43 11.714c1.741-2.89 5.672-8.463 7.464-7.63 2.239 1.04.746 2.775-1.493 3.121l-.054.01c-.974.169-.476 2.888-1.439 3.112v0c-1.194.277-1.99.116-2.612 0\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol